import type { RouteObject } from "react-router-dom";
import MainLayout from "../components/layout/MainLayout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import EventDetailPage from "../pages/event/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    element: <MainLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/category", element: <CategoryPage /> },
      { path: "/category/:slug", element: <CategoryPage /> },
      { path: "/event/:slug", element: <EventDetailPage /> },
      { path: "/about", element: <AboutPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;